'use strict';

var angular = require('angular');
var dependencies = ['AVRO.FaresOptimizer.Common.DataTransformer', 'AVRO.FaresOptimizer.HostLadderList'];
module.exports = angular.module('AVRO.FaresOptimizer.RecommendationHostPanel', dependencies).directive('rmRecommendationHostPanel', require('./directives/RecommendationHostPanelDirective'));